import { SxProps, Theme } from "@mui/material";

/**
 * @deprecated This function is just a mock to get rid of @mui/styles legacy package.
 * Do not use it in the new code
 */
export function makeStyles(
  params: any
): (theme?: Theme) => { [key in any]: SxProps<Theme> } {
  if (typeof params === "function") {
    return params;
  }
  return () => params;
}
